import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
export default {
  path: 'purchase',
  name: 'BusinessPurchase',
  component: EmptyRouterAlive,
  meta: {
    title: '采购管理',
  },
  children: [
    {
      path: 'supplier',
      name: 'BusinessPurchaseSupplier',
      component: EmptyRouter,
      redirect: 'supplier/index',
      meta: {
        title: '供应商管理',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessPurchaseSupplier',
          component: () => import('@/views/center-business/purchase/supplier'),
          meta: {
            title: '供应商管理',
            isCache: true,
          },
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierIndex_Add',
          meta: {
            title: '新增-供应商',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierIndex_ExcelImport',
          meta: {
            title: 'EXCEL导入-供应商',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierIndex_Export',
          meta: {
            title: '导出-供应商',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierIndex_Edit',
          meta: {
            title: '编辑-供应商',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierIndex_Status',
          meta: {
            title: '启用/禁用-供应商',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierIndex_Delete',
          meta: {
            title: '删除-供应商',
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'forecast',
      name: 'BusinessPurchaseForecast',
      component: EmptyRouter,
      redirect: 'forecast/index',
      meta: {
        title: '采购预测',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessPurchaseForecast',
          component: () => import('@/views/center-business/purchase/forecast'),
          meta: {
            title: '采购预测',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'inventory',
      name: 'BusinessInventoryPrediction',
      component: EmptyRouter,
      redirect: 'inventory/index',
      meta: {
        title: '库存预测报告',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessInventoryPrediction',
          component: () => import('@/views/center-business/purchase/inventory-prediction'),
          meta: {
            title: '库存预测报告',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'basics',
      name: 'BusinessPurchaseBasics',
      component: EmptyRouter,
      redirect: 'basics/index',
      meta: {
        title: '基础配置',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessPurchaseBasics',
          component: () => import('@/views/center-business/purchase/basics'),
          meta: {
            title: '基础配置',
            isCache: true,
          }
        },
      ],
    },
    {
      path: 'supplier-shop',
      name: 'BusinessPurchaseSupplierShop',
      component: EmptyRouter,
      redirect: 'supplier-shop/index',
      meta: {
        title: '供应商商品',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessPurchaseSupplierShop',
          component: () => import('@/views/center-business/purchase/supplier-shop'),
          meta: {
            title: '供应商商品',
            isCache: true,
          },
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierShopIndex_Add',
          meta: {
            title: '新增-供应商商品',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierShopIndex_ExcelImport',
          meta: {
            title: 'EXCEL导入-供应商商品',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierShopIndex_Edit',
          meta: {
            title: '修改-供应商商品',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierShopIndex_Export',
          meta: {
            title: '导出-供应商商品',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseSupplierShopIndex_Delete',
          meta: {
            title: '删除-供应商商品',
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'apply',
      name: 'BusinessPurchaseApply',
      component: EmptyRouter,
      redirect: 'apply/index',
      meta: {
        title: '采购申请单',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessPurchaseApply',
          component: () => import('@/views/center-business/purchase/apply'),
          meta: {
            title: '采购申请单',
            isCache: true,
          },
        },
        {
          path: 'detail',
          name: 'BusinessPurchaseApplyDetail',
          component: () => import('@/views/center-business/purchase/apply/detail'),
          meta: {
            title: '采购申请单详情',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'purchaseDetail',
          name: 'BusinessPurchaseDetail',
          component: () => import('@/views/center-business/purchase/order/detail'),
          meta: {
            title: '采购单详情',
          },
          hidden: true,
        },
        {
          path: 'add',
          name: 'BusinessPurchaseApplyIndexAdd',
          component: () => import('@/views/center-business/purchase/apply/add'),
          meta: {
            title: '新增采购申请单',
            isCache: false,
          },
          hidden: true,
        },
        {
          path: 'edit',
          name: 'BusinessPurchaseApplyIndexEdit',
          component: () => import('@/views/center-business/purchase/apply/edit'),
          meta: {
            title: '编辑采购申请单',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'copy',
          name: 'BusinessPurchaseApplyIndexCopy',
          component: () => import('@/views/center-business/purchase/apply/copy'),
          meta: {
            title: '复制采购申请单',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseApplyIndex_Add',
          meta: {
            title: '新增-采购申请单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseApplyIndex_ExcelImport',
          meta: {
            title: 'Excel导入-采购申请单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseApplyIndex_Updata',
          meta: {
            title: '编辑-采购申请单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseApplyIndex_Audit',
          meta: {
            title: '审核-采购申请单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseApplyIndex_UnAudit',
          meta: {
            title: '反审核-采购申请单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseApplyIndex_Close',
          meta: {
            title: '关闭申请-采购申请单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseApplyIndex_Cancel',
          meta: {
            title: '取消-采购申请单',
          },
          hidden: true,
        },
        {
          path: 'change-purchase',
          name: 'BusinessPurchaseApplyChangePurchase',
          component: () => import('@/views/center-business/purchase/apply/change-purchase'),
          meta: {
            title: '转采购单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseApplyIndex_Export',
          meta: {
            title: '导出-采购申请单',
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'order',
      name: 'BusinessPurchaseOrder',
      component: EmptyRouter,
      redirect: 'order/index',
      meta: {
        title: '采购单管理',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessPurchaseOrder',
          component: () => import('@/views/center-business/purchase/order'),
          meta: {
            title: '采购单管理',
            isCache: true,
          },
        },
        {
          path: 'add',
          name: 'BusinessPurchaseOrderIndexAdd',
          component: () => import('@/views/center-business/purchase/order/csg/add'),
          meta: {
            title: '新增采购单',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'edit',
          name: 'BusinessPurchaseOrderIndexEdit',
          component: () => import('@/views/center-business/purchase/order/csg/edit'),
          meta: {
            title: '修改采购单',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'detail',
          name: 'BusinessPurchaseOrderIndexDetail',
          component: () => import('@/views/center-business/purchase/order/detail'),
          meta: {
            title: '采购单详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseOrderIndex_Import',
          meta: {
            title: '导入采购单-采购单管理',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseOrderIndex_Audit',
          meta: {
            title: '审核-采购单管理',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseOrderIndex_UnAudit',
          meta: {
            title: '反审核-采购单管理',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseOrderIndex_Finish',
          meta: {
            title: '完成采购-采购单管理',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseOrderIndex_Cancel',
          meta: {
            title: '取消采购单-采购单管理',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseOrderIndex_Export',
          meta: {
            title: '导出-采购单管理',
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'getLow',
      name: 'BusinessPurchaseGetLow',
      component: EmptyRouter,
      redirect: 'getLow/index',
      meta: {
        title: '统计SKU降低成本',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessPurchaseGetLow',
          component: () => import('@/views/center-business/purchase/getLow'),
          meta: {
            title: '统计SKU降低成本',
            isCache: true,
          },
          permissionType: 'tab',
          hidden: true,
        },
      ]
    },
    {
      path: 'Timeliness',
      name: 'BusinessPurchaseTimeliness',
      component: EmptyRouter,
      redirect: 'Timeliness/index',
      meta: {
        title: '返单及时率',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessPurchaseTimeliness',
          component: () => import('@/views/center-business/purchase/Timeliness'),
          meta: {
            title: '返单及时率',
            isCache: true,
          },
          permissionType: 'tab',
          hidden: true,
        },
      ]
    },
    {
      path: 'entry',
      name: 'BusinessPurchaseEntry',
      component: EmptyRouter,
      redirect: 'entry/inform',
      meta: {
        title: '采购入库单',
      },
      children: [
        {
          path: 'inform',
          name: 'BusinessPurchaseEntryInform',
          component: () => import('@/views/center-business/purchase/entry/inform'),
          meta: {
            title: '采购入库通知单',
            isCache: true,
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'inform/add',
          name: 'BusinessPurchaseEntryInformAdd',
          component: () => import('@/views/center-business/purchase/entry/inform/add'),
          meta: {
            title: '新增采购入库通知单',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'inform/edit',
          name: 'BusinessPurchaseEntryInformEdit',
          component: () => import('@/views/center-business/purchase/entry/inform/edit'),
          meta: {
            title: '编辑采购入库通知单',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'inform/detail',
          name: 'BusinessPurchaseEntryInformDetail',
          component: () => import('@/views/center-business/purchase/entry/inform/detail'),
          meta: {
            title: '采购入库通知单详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseEntryInform_Audit',
          meta: {
            title: '审核-采购入库通知单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseEntryInform_UnAudit',
          meta: {
            title: '反审核-采购入库通知单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseEntryInform_Cancel',
          meta: {
            title: '取消-采购入库通知单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseEntryInform_Confirm',
          meta: {
            title: '确认入库-采购入库通知单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseEntryInform_Export',
          meta: {
            title: '导出-采购入库通知单',
          },
          hidden: true,
        },
        {
          path: 'result',
          name: 'BusinessPurchaseEntryResult',
          component: () => import('@/views/center-business/purchase/entry/result'),
          meta: {
            title: '采购入库结果单',
            isCache: true,
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'result/detail',
          name: 'BusinessPurchaseEntryResultDetail',
          component: () => import('@/views/center-business/purchase/entry/result/detail'),
          meta: {
            title: '采购入库结果单详情',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseEntryResult_Export',
          meta: {
            title: '导出-采购入库结果单',
          },
          hidden: true,
        },
      ],
    },
    {
      path: 'return',
      name: 'BusinessPurchaseReturn',
      component: EmptyRouter,
      redirect: 'return/inform',
      meta: {
        title: '采购退货单',
      },
      children: [
        {
          path: 'inform',
          name: 'BusinessPurchaseReturnInform',
          component: () => import('@/views/center-business/purchase/return/inform'),
          meta: {
            title: '采购退货出库通知单',
            isCache: true,
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'result',
          name: 'BusinessPurchaseReturnResult',
          component: () => import('@/views/center-business/purchase/return/result'),
          meta: {
            title: '采购退货出库结果单',
            isCache: true,
          },
          permissionType: 'tab',
          hidden: true,
        },
        {
          path: 'inform/detail',
          name: 'BusinessPurchaseReturnInformDetail',
          component: () => import('@/views/center-business/purchase/return/inform/detail'),
          meta: {
            title: '采购退货通知单详情',
          },
          hidden: true,
        },
        {
          path: 'result/detail',
          name: 'BusinessPurchaseReturnResultDetail',
          component: () => import('@/views/center-business/purchase/return/result/detail'),
          meta: {
            title: '采购退货结果单详情',
          },
          hidden: true,
        },
        {
          path: 'inform/add',
          name: 'BusinessPurchaseReturnInformAdd',
          component: () => import('@/views/center-business/purchase/return/inform/add'),
          meta: {
            title: '新增采购退货单',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: 'inform/edit',
          name: 'BusinessPurchaseReturnInformEdit',
          component: () => import('@/views/center-business/purchase/return/inform/edit'),
          meta: {
            title: '编辑采购退货单',
            isCache: true,
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseReturnInform_Audit',
          meta: {
            title: '审核-采购退货单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseReturnInform_UnAudit',
          meta: {
            title: '反审核-采购退货单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseReturnInform_Cancel',
          meta: {
            title: '取消-采购退货单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseReturnInform_Return',
          meta: {
            title: '退货出库-采购退货单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseReturnInform_Export',
          meta: {
            title: '导出-采购退货单',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessPurchaseReturnResult_Export',
          meta: {
            title: '导出-采购退货出库结果单',
          },
          hidden: true,
        },
        // {
        //   path: '',
        //   name: 'BusinessPurchaseReturnInform_Log',
        //   meta: {
        //     title: '日志-采购退货单',
        //   },
        //   hidden: true,
        // },
      ],
    },
  ],
};
